import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '../assets/oj-logo.jpg'


const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }

import { routes } from "@/router/routes";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import checkAccess from "@/access/checkAcess";


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const store = useStore();
// 路由
const router = useRouter();
const visibleRoutes = computed(() => {
  return routes.filter((item) => {
    //是否在菜单中可见及剔除管理、发布菜单
    if (
      item.meta?.hideInMenu ||
      item.name?.slice(0, 2) === "管理" ||
      item.name?.slice(0, 2) === "发布" ||
      item.name?.slice(0, 2) === "审核"
    )
      return false;
    //鉴权
    return checkAccess(
      store.state.user.loginUser,
      item?.meta?.access as string
    );
  });
});
const manageMenu = computed(() => {
  return routes.filter((item) => {
    //是否以管理开头或者为审核
    return (
      (item.name?.startsWith("管理") || item.name?.startsWith("审核")) &&
      !item.meta?.hideInMenu &&
      checkAccess(store.state.user.loginUser, item?.meta?.access as string)
    );
  });
});
const createMenu = computed(() => {
  return routes.filter((item) => {
    //是否以发布开头
    return (
      item.name?.startsWith("发布") &&
      !item.meta?.hideInMenu &&
      checkAccess(store.state.user.loginUser, item?.meta?.access as string)
    );
  });
});
const isSelectedCreate = ref(false);
const isSelectedManage = ref(false);
const selectedKeys = ref(["/"]); //默认是主页
//路由跳转时更新选中菜单项
router.afterEach((to) => {
  selectedKeys.value = [to.path];
  isSelectedManage.value = to.path.startsWith("/manage");
  isSelectedCreate.value = to.path.startsWith("/add");
});
const toPath = (toPath: string) => {
  router.push({ path: toPath });
};

//用户栏
const showName = computed(() => {
  return store.state.user?.loginUser?.userName ?? "未登录";
});
const userRole = computed(() => {
  return store.state.user?.loginUser?.userRole ?? "user";
});
const userId = computed(() => {
  return store.state.user?.loginUser?.userId ?? -1;
});
const toLogin = () => {
  if (showName.value === "未登录") {
    router.push({ path: "/user/login", replace: true });
  }
};
const logOut = () => {
  store.dispatch("user/logoutUser");
  router.push({ path: "/", replace: true });
};

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    wrap: false,
    align: "center",
    style: {"margin-bottom":"16px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_menu, {
              "selected-keys": selectedKeys.value,
              mode: "horizontal",
              onMenuItemClick: toPath
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "0",
                  style: { padding: 0, marginRight: '38px' },
                  disabled: ""
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "title-bar" }, [
                      _createElementVNode("img", {
                        alt: "oj-logo",
                        class: "logo",
                        src: _imports_0
                      }),
                      _createElementVNode("div", { class: "title" }, "My OJ")
                    ], -1)
                  ])),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: item.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (userRole.value === 'admin' || userRole.value === 'user')
                  ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createMenu.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_doption, {
                            key: item.path,
                            onClick: ($event: any) => (toPath(item.path))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          style: _normalizeStyle({ color: isSelectedCreate.value ? '#165dff' : '#4e5969' }),
                          type: "text"
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode(" 发布 ")
                          ])),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (userRole.value === 'admin')
                  ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 1 }, {
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manageMenu.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_doption, {
                            key: item.path,
                            onClick: ($event: any) => (toPath(item.path))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          style: _normalizeStyle({ color: isSelectedManage.value ? '#165dff' : '#4e5969' }),
                          type: "text"
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode(" 管理 ")
                          ])),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["selected-keys"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "250px" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_link, {
            href: "/user/register",
            style: {"margin-right":"32px"}
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("注册账号")
            ])),
            _: 1
          }),
          _createVNode(_component_a_dropdown, { trigger: 'hover' }, {
            content: _withCtx(() => [
              (showName.value === '未登录')
                ? (_openBlock(), _createBlock(_component_a_doption, {
                    key: 0,
                    onClick: toLogin
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("登录 ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (showName.value !== '未登录')
                ? (_openBlock(), _createBlock(_component_a_doption, {
                    key: 1,
                    onClick: logOut
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("退出登录 ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (showName.value !== '未登录')
                ? (_openBlock(), _createBlock(_component_a_doption, {
                    key: 2,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (toPath(`/center/${userId.value}`)))
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("用户中心 ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_avatar, {
                style: _normalizeStyle({
            backgroundColor:
              showName.value === '未登录'
                ? '#c9cdd4'
                : showName.value === 'admin'
                ? '#00d0b6'
                : '#14a9f8',
          })
              }, {
                default: _withCtx(() => [
                  (_unref(store).state.user.loginUser?.userAvatar !== '')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        alt: "avatar",
                        src: _unref(store).state.user.loginUser?.userAvatar
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(showName.value), 1))
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})